const API_BASE = import.meta.env.VITE_API_URL || '/api';
async function request(endpoint, options) {
    try {
        const token = localStorage.getItem('ubuntu_token');
        const headers = {
            'Content-Type': 'application/json',
        };
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        const response = await fetch(`${API_BASE}${endpoint}`, {
            ...options,
            headers: {
                ...headers,
                ...options?.headers,
            },
        });
        if (!response.ok) {
            const error = await response.text().catch(() => 'Unknown error');
            return { ok: false, error };
        }
        const data = await response.json();
        return { ok: true, data };
    }
    catch (error) {
        return { ok: false, error: error instanceof Error ? error.message : 'Network error' };
    }
}
export function fetchTownSignals() {
    return request('/field/signals');
}
export function fetchMyAssignments() {
    return request('/field/assignments/me');
}
export function acceptAssignment(assignmentId) {
    return request(`/field/assignments/${assignmentId}/accept`, {
        method: 'POST',
    });
}
export function startAssignment(assignmentId) {
    return request(`/field/assignments/${assignmentId}/start`, {
        method: 'POST',
    });
}
export function submitProof(assignmentId, proof) {
    return request(`/field/assignments/${assignmentId}/submit-proof`, {
        method: 'POST',
        body: JSON.stringify(proof),
    });
}
export function fetchProfile() {
    return request('/profile/me');
}
export function updateProfile(profile) {
    return request('/profile/me', {
        method: 'PUT',
        body: JSON.stringify(profile),
    });
}
export async function login(credentials) {
    const response = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
    });
    if (!response.ok) {
        return { ok: false, error: 'Login failed' };
    }
    const data = await response.json();
    return { ok: true, data };
}
export async function loginTelegram(displayName, initData) {
    const response = await fetch(`${API_BASE}/auth/telegram`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ display_name: displayName, telegram_init_data: initData }),
    });
    if (!response.ok) {
        return { ok: false, error: 'Telegram login failed' };
    }
    const data = await response.json();
    return { ok: true, data };
}
//# sourceMappingURL=api.js.map